<div class="modal-header">
  <button type="button" class="close" ng-click="closeModalDuplicacao()">×</button>
  <h4 class="modal-title">Duplicar Recomendação</h4>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-xs-12">
      <p>
        Você pode selecionar outra propriedade de destino para duplicar esta recomendação, ou apenas clique em <b>Confirmar</b> para usar a atual.
      </p>
    </div>
  </div>
  <div class="row">
    <div class="col-xs-12">
      <div class="form-group">
        <select ng-model="duplicateToPropriedade" class="form-control">
          <option value="">Atual</option>
          <option ng-repeat="propriedade in $root.propriedades" ng-value="propriedade" ng-if="propriedade.id !== $root.currentPropriedade.id">{{propriedade.descricao}}</option>
        </select>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer text-right">
  <button class="btn" ng-click="closeModalDuplicacao()">Cancelar</button>
  <button class="btn btn-primary" ng-click="confirmDuplication(duplicateToPropriedade)">Duplicar</button>
</div>
